import Vue from "vue";
import App from "./App.vue";
import i18n from './i18n'

import { router } from "./router";
import store from "./store";

import axios from 'axios'
import VueAxios from 'vue-axios'

import VueSweetalert2 from 'vue-sweetalert2';
import Paginate from 'vuejs-paginate'

import AuthMixin from '@/mixins/Auth';
import CrudMixin from '@/mixins/Crud';

import DatePicker from '@/components/inputs/DatePicker'
import Notice from '@/components/Notice'
import Flexible from '@/components/Flexible'
import Button from '@/components/Button'
import wysiwyg from "vue-wysiwyg";

import { sync } from 'vuex-router-sync'

sync(store, router)

Vue.component('paginate', Paginate)
Vue.component('Notice', Notice)
Vue.component('Flexible', Flexible)
Vue.component('Button', Button)
Vue.component('datepicker', DatePicker);

Vue.use(VueAxios, axios)
Vue.use(wysiwyg)
Vue.use(VueSweetalert2)
Vue.mixin(AuthMixin)
Vue.mixin(CrudMixin)

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
